import React from 'react';

import { BrandLogo as AsenionLogoLight } from './asenion-logo';
import { BrandLogo as AsenionLogoDark } from './asenion-logo-dark';
import { SonyLogo } from './sony-logo';
import { TrueLogo } from './true-logo';

interface LogoSelectorProps {
  prefersDarkMode?: boolean;
}

export const LogoSelector: React.FC<LogoSelectorProps> = ({
  prefersDarkMode = false,
}) => {
  // Check if we're in a browser environment (client-side)
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : '';

  // Check if it's the Sony environment
  const isSonyEnvironment = baseUrl.includes('sony.asenion.app');
  const isTrueEnvironment = baseUrl.includes('true.asenion.app');

  if (isSonyEnvironment) {
    return <SonyLogo />;
  }
  if (isTrueEnvironment) {
    return <TrueLogo />;
  }
  return prefersDarkMode ? <AsenionLogoLight /> : <AsenionLogoDark />;
};

export default LogoSelector;
